import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tvcr3rrcqs: FaireBrandEntity = {
  token: "b_tvcr3rrcqs",
  type: "brand",
  name: "b-one inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/aff47074063ba10079291798d556b1bdb9850e282fab9154dc6ae49f6847730c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/47a639d829ec9f6f312abc4b75d4b2fde4b1a12dcfb2c80bbeb06aae28f8ba32.png",
  logoUrl:
    "https://cdn.faire.com/fastly/aff47074063ba10079291798d556b1bdb9850e282fab9154dc6ae49f6847730c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/47a639d829ec9f6f312abc4b75d4b2fde4b1a12dcfb2c80bbeb06aae28f8ba32.png",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 29,
  isInsider: true,
  description:
    "B-One inc. is a wholesaler and distributor of wide range of children's clothing since 1990. We offer a wide collection of apparel for newborn babies, toddlers, little and, big kids and in different size categories.  Our collection includes: \n\nBoys Formal Wear:\nBoys suits, tuxedoes, formal outfit sets, dress shirt, dress pants, baptism & christening outfits and sets, and all related accessories. \nChildren's Casual Wear: \n2 piece and 3 piece Outfit Sets, tee shirts, kids athletic wear, shorts, and many more\nChildren's Undergarments and Essentials:\nBoys and girls tank tops and undershirts, baby bodysuits & essentials, underwear, and more\nMade in Mexico Newborn Crochet Blankets and Outfit Sets\n5 Piece Blanket Sets, 4 Piece Pants Sets, 3 Piece Sets, and 2 Piece Dress Sets. \nWe are conveniently located in downtown Los Angeles and work with many manufacturers and suppliers which makes it easy for us to have access to unlimited inventory and with unbeatable prices.  We offer our on hand inventory and collection to businesses such as kids boutique stores, bridal shops, swap meets and flea market sellers, other children's apparel retailors, and group buyers. \n\nOur mission is to provide simple and easy one-stop shopping to our customers. One phone call, one order, one shipment, is how we differentiate ourselves from other children’s clothing wholesalers and distributors.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:31.694Z",
    importedBy: "entity-db-cli",
  },
};
